import { Component, OnInit, Input, AfterViewChecked } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import 'parse';
const parse: typeof Parse = require('parse');

//declare const $: any;

@Component({
  selector: 'app-parameters-header',
  templateUrl: './parameters-header.component.html',
  styleUrls: ['./parameters-header.component.less']
})
export class ParametersHeaderComponent implements OnInit, AfterViewChecked {
  @Input() activeSection: string;
  showParameters: boolean;
  privateCompany: boolean;
  isSuperAdmin = false;

  constructor(private _route: ActivatedRoute,
    private readonly _router: Router) {
    this.privateCompany = parse.User.current().get('privateCompany');
    this.isSuperAdmin = parse.User.current().get('isSuperAdmin');
    if (this._router.url === "/parameters")
      this.showParameters = true
    else
      this.showParameters = false
  }

  ngOnInit() {

  }

  ngAfterViewChecked(): void {
    //Called after every check of the component's view. Applies to components only.
    //Add 'implements AfterViewChecked' to the class.
    $(window).on('scroll', () => {
      if (window.innerWidth < 992 && $(window).scrollTop() > 154) {

        $(`#${this.activeSection}-header`).get(0).scrollIntoView({
          inline: 'start'
        });

      }
    });
  }

  scrollTo(section: string) {
    $(`#${section} > .section-scroll-anchor`).get(0).scrollIntoView({
      block: 'start'
    });
  }

}


// WEBPACK FOOTER //
// ./src/app/element/parameters-header/parameters-header.component.ts